'use strict';
import variant from './pages/product/variant';
import minicart from './minicart';
import customModal from './modal';
import currentLayout from './detect-layout';
import util from './util';
import buyallutil from './buyall-util';
import delayImage from './delay-image';
import analytics from './analytics';
import header from './header';
import customDropdown from './custom-dropdown';
import ajax from './ajax';
import search from './pages/search';
import analyticsEmea from './analyticsBase';
import imagesLoaded from 'imagesloaded';

let currLayoutVal = currentLayout.init();
let flagToSetTileHeight = true;

function gridViewToggle() {
	$('.toggle-grid').on('click', function () {
		$('.search-result-content').toggleClass('wide-tiles');
		$(this).toggleClass('wide');
	});
}

var slideSettings = {
	color: {
		list: [5, 5, 6, 6, 5],
		grid: [5, 3, 3, 2, 2]
	},
	size: {
		list: [3, 3, 3, 3, 3],
		grid: [2, 1, 1, 1, 1]
	}
}

function carouselSettings(varient) {
	var currentView = 'grid';
	var carouselView = slideSettings[varient];
	if ($('.product-tiles-holder').hasClass('list-view')) {
		currentView = 'list';
	}
	return [
		{ breakpoint: 1300, settings: { slidesToShow: carouselView[currentView][0], slidesToScroll: carouselView[currentView][0] } },
		{ breakpoint: 769, settings: { slidesToShow: carouselView[currentView][1], slidesToScroll: carouselView[currentView][1] } },
		{ breakpoint: 601, settings: { slidesToShow: carouselView[currentView][2], slidesToScroll: carouselView[currentView][2] } },
		{ breakpoint: 451, settings: { slidesToShow: carouselView[currentView][3], slidesToScroll: carouselView[currentView][3] } },
		{ breakpoint: 321, settings: { slidesToShow: carouselView[currentView][4], slidesToScroll: carouselView[currentView][4] } }
	];
}

function initCarouselSwatchesHandler(tileOuter, swatchInitialIndex, ajaxCall) {
	//Init event, make swatches left aligned if number of items less than to show
	$('.tile-carousel').on('init', function(event, slick){
		if(slick.$nextArrow.hasClass('slick-hidden')) {
			$(this).addClass('left-aligned-slick');
		} else {
			$(this).removeClass('left-aligned-slick');
		}
	});

	//Init event, make swatches left aligned if number of items less than to show
	//Upon resolution change
	$('.tile-carousel').on('breakpoint', function(event, slick){
		if(slick.$nextArrow.hasClass('slick-hidden')) {
			$(this).addClass('left-aligned-slick');
		} else {
			$(this).removeClass('left-aligned-slick');
		}
	});

	$('.tile-color-carousel').not('.slick-initialized').slick({
		dots: false,
		infinite: false,
		slidesToShow: 5,
		slidesToScroll: 5,
		speed: 300,
		rows: 0,
		responsive: carouselSettings('color'),
		prevArrow: '<button class="slide-arrow slick-prev"></button>',
    	nextArrow: '<button class="slide-arrow slick-next"></button>'
	});
	
	function isOverflowSizeShade() {
		var $colorCategoryWrapper = $('.tile-size-carousel:not(.slick-initialized)'),
			$colorCategoryTile = $('.regimenzone .tile-size-carousel:not(.slick-initialized) .size-variant'),
			totalWidth = 0;
	
		if($colorCategoryWrapper.length && $colorCategoryTile.length) {
			$colorCategoryTile.each(function(index) {
				totalWidth += $(this).outerWidth();
			});
			return $colorCategoryWrapper.width() <= totalWidth;
		}	
	}

	const isRegimenZonePresent = $('.regimenzone .tile-size-carousel').length == 0;
	var $sizeCategory = $('.tile-size-carousel');
	if ($sizeCategory.length && isOverflowSizeShade()) {
		$('.tile-size-carousel').not('.slick-initialized').slick({
			dots: false,
			infinite: $('.regimenzone .tile-size-carousel').length ? false : true,
			slidesToShow: $('.regimenzone .tile-size-carousel').length ? 4 : 3,
			slidesToScroll: $('.regimenzone .tile-size-carousel').length ? 4 : 3,
			variableWidth: true,
			speed: 300,
			rows: 0,
			responsive: isRegimenZonePresent ? carouselSettings('size') : [
				{
					breakpoint: 1024, // Tablet and smaller devices
					settings: {
						slidesToShow: 4,
						slidesToScroll: 4,
					}
				},
				{
					breakpoint: 768, // Mobile devices
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
					}
				}
			],
			prevArrow: '<button class="slide-arrow slick-prev"></button>',
			nextArrow: '<button class="slide-arrow slick-next"></button>'
		});
	}
	

	
	if (ajaxCall) {
		tileOuter.find('.tile-color-carousel').hide().slick(
			'slickGoTo', swatchInitialIndex
		).show();
		tileOuter.find('.tile-size-carousel').hide().slick(
			'slickGoTo', swatchInitialIndex
		).show();
		if(!util.isTouchScreen()) {
			tileOuter.find('.color-variant .swatch[title]').each(function() {
				$(this).attr('title', util.capitalizeFirstLetters($(this).attr('title')));
			});
		}
	} else {
		initialSlideHandler();
		if(!util.isTouchScreen()) {
			$('.color-variant .swatch[title]').each(function() {
				$(this).attr('title', util.capitalizeFirstLetters($(this).attr('title')));
			});
		}
	}

	regimenColorCarousel();
}

function destroyQuickshopCarouselSwatches(){
	var $swatchCarousel = $('.quick-shop-panel .tile-color-carousel, .quick-shop-panel .tile-size-carousel'),
		isMobile = util.isMobile();

	if(!$swatchCarousel.length) 
		return;	
	if ($swatchCarousel.hasClass('slick-initialized') && isMobile) {
		$swatchCarousel.slick('destroy');
	}
}

/*
 * Function:
 * Default selected swatch visibility on the slide(Both color and size carousel).
 * Call on page load and during grid/list view switching
 */
function initialSlideHandler() {
	$('.product-tile').each(function () {
		if ($(this).find('.tile-carousel span').length > 0) {
			var selectedSwatch = $(this).find('span.selected').eq(0).index();
			$(this).find('.tile-carousel').hide().slick(
				'slickGoTo', selectedSwatch
			).show();
		}
	});
}

function tileQuantitySelect() {
	$('.tile-cta-warpper select').selectmenu({
		width: false,
		position: {
			my: "left top",
			at: "left bottom",
			collision: "flip flip"
		},
		classes: {
			"ui-selectmenu-menu": "tileQtySelector"
		}
	});

	$('.tile-cta-warpper select').on('selectmenuchange change', function (event) {
		var tileQtyId = 'select#' + $(this).attr('id');
		var $tileOuter = $(this).closest('.product-tile-inner');
		var $pid = $tileOuter.find('.product-tile').data('itemid');
		var $qty = $(this).find('option:selected').val();
		if (updatePIDsReq($tileOuter)) {
			buyallutil.updateqty($pid, $qty);
		}

		if ($(tileQtyId).hasClass('quantity')) {
			tileMouseHandler();
		}
	});
}

$(document).ready(function () {
	if ($('.page-not-found-404').length) {
		setTimeout(() => {
			tileQuantitySelect();
		}, 5000);
	}
	$('.search-result-wrapper .product-grids-container .search-result-items .product-grid .tile-push-container').css('aspect-ratio', ' ');
});

if ($('.page-not-found-404').length) {
	document.addEventListener('readystatechange', event => {
		// When window loaded ( external resources are loaded too- `css`,`src`, etc...) 
		if (event.target.readyState === "complete") {
			tileQuantitySelect();
		}
	});
}

function shopByCategory() {
	$('#clp-collection-select').on('selectmenuchange change', function () {
		var categoryID = $(this).val();
		$('html, body').animate({
			scrollTop: $('#' + categoryID).offset().top - 55
		}, 500);
		$(this).selectmenu('refresh');
	});
}

var parseQueryString = function (url) {
	var urlParams = {};
	url.replace(
		new RegExp("([^?=&]+)(=([^&]*))?", "g"),
		function ($0, $1, $2, $3) {
			if (typeof $3 != "undefined") {
				urlParams[$1] = decodeURIComponent($3);
			}
		}
	);
	return urlParams;
}

function bindSwatchClick() {

	$('.tile-size-carousel a').off('click').on('click', function (e) {
		e.preventDefault();
		var $tileOuter = $(this).closest('.product-tile-inner'),
			$tileLoader = $tileOuter.find('.tile-ajax-loader'),
			swatchInitialIndex = $tileOuter.find('.tile-size-carousel span.slick-current').attr('data-slick-index');

		if ($(this).parent().hasClass('selected')) {
			return;
		}

		$tileLoader.show();
		$tileOuter.find('.thumb-link').attr('href', $(this).attr('href'));
		$tileOuter.find('name-link').attr('href', $(this).attr('href'));

		var urlToParse = $(this).attr('href'),
			result = JSON.parse(JSON.stringify(parseQueryString(urlToParse)));

		if (result && typeof result.pid == 'undefined') {
			result.pid = $tileOuter.find('.product-tile').data('masterpid');
		}
		if($(this).parents().hasClass('regimenzone')){        
            result.isregimenpropduct = true;
        }

		$.ajax({
			url: util.appendParamToURL(Urls.transactionalHitTile, 'format', 'ajax'),
			data: result,
			type: 'GET'
		}).done(function (data) {
			$('.product-tile-inner #a2c-error').hide();

			var oldPid = $tileOuter.find('.product-tile').data('itemid');
			$tileOuter.html(data);
			var newPid = $tileOuter.find('.product-tile').data('itemid');
			initCarouselSwatches($tileOuter, swatchInitialIndex, true);
			destroyQuickshopCarouselSwatches();	
			bindSwatchClick();
			tileQuantitySelect();
			$tileLoader.hide();
			if (updatePIDsReq($tileOuter)) {
				buyallutil.updatepid(oldPid, newPid);
			}
			if (result.isregimenpropduct == true) {
				toggleDisabilityRegimenButton(this);
			}
		});
	});

	$('.tile-color-carousel .swatch').off('click').on('click', function (e) {
		e.preventDefault();
		if ($(this).parent().hasClass('selected')) {
			return;
		}
		
		var $tileOuter = $(this).closest('.product-tile-inner'),
			swatchInitialIndex = $tileOuter.find('.tile-color-carousel span.slick-current').attr('data-slick-index'),
			$tileLoader = $tileOuter.find('.tile-ajax-loader');

		$tileLoader.show();
		$tileOuter.find('.thumb-link').attr('href', $(this).attr('href'));
		$tileOuter.find('.name-link').attr('href', $(this).attr('href'));

		var urlToParse = $(this).attr('href'),
			result = JSON.parse(JSON.stringify(parseQueryString(urlToParse)));

		if (result && typeof result.pid == 'undefined') {
			result.pid = $tileOuter.find('.product-tile').data('masterpid');
		}
		if($(this).parents().hasClass('regimenzone')){		
			result.isregimenpropduct = true;
			var regimenTileContent = $(this).parents('.product-tile').find('.content');
			result.content = regimenTileContent.length > 0 ? $.trim(regimenTileContent.text()) : "";
		}

		var $tile = $(this).closest('.product-tile');
		result.attrColorVals = $tile.attr('data-strAttrColorVals');
		result.fondationResultTile = $tile.attr('data-fondationResultTile');

		$.ajax({
			url: util.appendParamToURL(Urls.transactionalHitTile, 'format', 'ajax'),
			data: result,
			type: 'GET'
		}).done(function (data) {
			$('.product-tile-inner #a2c-error').hide();
			var productImage = new Image();
			var tileImageHeight = $tileOuter.find('.thumb-link').height();
			productImage.src = $(data).find('.thumb-image')[0].src;
			var oldPid = $tileOuter.find('.product-tile').data('itemid');
			$tileOuter.html(data);
			if($tileOuter.parents('.tiles-container').find('.product-tile-outer').length < 2){
				$tileOuter.find('.thumb-link').height(tileImageHeight);
			}
			var newPid = $tileOuter.find('.product-tile').data('itemid');
			initCarouselSwatches($tileOuter, swatchInitialIndex, true);
			//if regmen add-all-to-cart button
			if(result.isregimenpropduct){
				toggleDisabilityRegimenButton($(this));
			}
			destroyQuickshopCarouselSwatches();
			bindSwatchClick();
			tileQuantitySelect();
			$tileLoader.hide();
			if (updatePIDsReq($tileOuter)) {
				buyallutil.updatepid(oldPid, newPid);
			}
			productImage.onload = function(){
				$tileOuter.find('.thumb-link').removeAttr('style');
			}
			
			//reinit swatches
			$('.quick-shop-panel__body .product-tile select').selectmenu();
		});
	});

	$(document).off('click', '.plp-cross-sell .product-tile button.add-to-cart, .product-tile-inner button.add-to-cart, .quick-shop-panel button.add-to-cart, .crosssell-recommendations-tile button.add-to-cart', addToCartClickHandler);
	$(document).on('click', '.plp-cross-sell .product-tile button.add-to-cart, .product-tile-inner button.add-to-cart, .quick-shop-panel button.add-to-cart, .crosssell-recommendations-tile button.add-to-cart', addToCartClickHandler);	
}

function addToCartClickHandler(e) {
	e.preventDefault();
	e.stopPropagation();
	var $tile = $(this).closest('.product-tile');
	var $tileOuter = $(this).closest('.product-tile-inner');
	var $cartAction = $(this).data('cartaction');
	var $pid = $(this).data('pid');
	var $qty = $tile.find('.quantity option:selected').val();

	if ($tile.find('#a2c-error').hasClass('active')) {
		return;
	} else {
		$('.product-tile-inner #a2c-error').hide();
	}
	
	var redirectHref = $tileOuter.find('.thumb-link').attr('href');
	if ($pid == 'undefined') {
		$pid = $tile.data('masterpid');
	}
	var $data = {
		"format": "ajax",
		"pid": $pid,
		"Quantity": $qty,
		"cartAction": $cartAction,
		"source":'plpquickview'
	}
	
	var isMobile = util.isMobile();
	
	//Product Set- redirect
	if($(this).data('isproductset') || (!quickViewEnabled && !$(this).data('cartflag')) ){
		$('.quick-shop-panel').hide();
		window.location.href = redirectHref;
		return;
	}
	
	//quick view slider
	if(quickViewEnabled && !$(this).data('cartflag')){
		if ($(this).closest(".plp-cross-sell").length) {
			analytics.quickViewOpenFromPLPCrosssell($(this));
		}
		getProductTile($data,$(this).find('.label').data('label'));
	}

	//add To cart for product
	if((!quickViewEnabled && $(this).data('cartflag')) || $(this).data('addtocart')){
		tileaddItemToCart($data, $tile).then(function (response) {
			$(document).trigger("gtadd-to-cart");
			
			if (window.pageContext.ns !== 'cart') {
				// show minicart slide panel only in mobile view
				minicart.crosssellRecommendationModal();
				minicart.show(response, true);  // true parameter enables minicart's slide right animation
				openMinicartSlidPanel();
			}
		}.bind(this));
	}
}

$.fn.isInViewport = function() {
	var elementTop = $(this).offset().top;
	var elementBottom = elementTop + $(this).outerHeight();
	
	var viewportTop = $(window).scrollTop();
	var viewportBottom = viewportTop + $(window).height();
	
	return elementBottom > viewportTop && elementTop < viewportBottom;
};
 
function tileaddItemToCart($data, $tile) {
	$tile.find('.add-to-cart').addClass('error');
	return Promise.resolve($.ajax({
		type: 'POST',
		url: util.ajaxUrl(Urls.addProduct),		
		data: $data
	})).then(function (response) {
		// handle error in the response
		if (response.error) {
			if (response.error === "Basket Limit Exceed") {
				var url = util.appendParamToURL(Urls.basketLimitExceed, 'format', 'ajax');
				$.ajax({
					url: url,
					dataType: 'html',
					success: function (response) {
						customModal.createCustomModal('addProduct-error-modal', '#modal-custom-placeholder');
						$('.addProduct-error-modal').find('.modal-body').html(response).scrollBox();
					}
				});
				$tile.find('.add-to-cart').removeClass('error');
				throw new Error(response.error);
				return false;
			} else {
				$tile.find('#a2c-error').html(response.error).addClass('active').slideDown('fast', function () {
					setTimeout(function () {
						$tile.find('#a2c-error').slideUp(500, function () {
							$(this).removeClass('active');
							$tile.find('.add-to-cart').removeClass('error');
						});
					}, 2000);
				});
				throw new Error(response.error);
				return false;
			}

		} else {
			$tile.find('#a2c-error').hide();
			$tile.find('.add-to-cart').removeClass('error');
		}

		return response;
	});
}

// quick shop Product info events

function getProductTile(data, labelText){
	$.ajax({
		url: Urls.transactionalHitTile,
		data: data,
		type: 'GET'
	}).done(function (resp) {
		if(!resp.trim() == '') {
			$('.quick-shop-panel').removeAttr('style').addClass('opened');
			$('.crosssell-recommendation-modal').removeClass('active');
			localStorage.setItem('quickview', 'open_quickview');
			setTimeout(function(){$('.quick-shop-panel .add-to-cart-sticky').addClass('show')}, 600);
			$('html').addClass('filter-open modal-open');
			$('.quick-shop-panel .panel-header h3').html(labelText);
			$('.quick-shop-panel .panel-body').html(resp);
			if (window.User.isCustomerAuthenticated && $('.quick-shop-panel .coming-soon-wrapper').length) {
				$('.quick-shop-panel .coming-soon-wrapper').removeClass('coming-soon-wrapper').addClass('coming-soon-wrapper_registered');
			}
			$("#quick-shop-panel .add-routine-wrapper").hide();
			quickViewImageSlider();
			customDropdown.init();
			initColorCatFiltersEvents();
			initColorCategoryFilter();
			initColorShadesSlider();
			scrollToActiveSizeVariant();
			applyTransparentGradientOnScroll();
			ominibusTooltip();
		}
		
	});
}

function quickViewImageSlider() {
	let slider = $(".quick-shop-panel #thumbnails .product-images");

			// If the slider is not initialized, initialize it
			if (!$(slider).hasClass('slick-initialized')) {
				$(slider).slick({
					initialSlide: 0,
					autoplay: false,
					arrows: true,
					dots: true,
					infinite: false,
					slidesToShow: 1,
					responsive: [
						{
							breakpoint: 800,
							settings: {
								arrows: false,
							}
						}
					]
				});
			}

	// Check if the product page is the PDP redesign and has video thumbnails
	if ($('.quick-shop-panel .video-thumbnail-wrapper').length > 0) {
		// Add a unique ID to each video element
		$('.quick-shop-panel .productthumbnail .video-thumbnail-wrapper').parent().addClass('video-thumbnail');
		$('.quick-shop-panel .video-thumbnail-wrapper .product-vid').each(function (index, value) {
			$(this).attr('id', 'thumnailvideo_' + index);
		});

		setTimeout(() => {
			var videos = $('.quick-shop-panel .video-thumbnail-wrapper video');

			$(document).on('click', '.quick-shop-panel .product-images .slick-slide.slick-current.slick-active > div', function (evt) {
				evt.preventDefault();
				evt.stopPropagation();

				var video = $('.quick-shop-panel .video-thumbnail-wrapper .product-vid');
				var videoID = $(this).parent().find('.product-vid');

				if (videoID && videoID.length > 0) {
					videoID = videoID.attr('id').split('_');

					if (videoID && videoID.length > 1) {
						$('.quick-shop-panel .video-thumbnail-wrapper .vid-thumbnail-play-btn').addClass('in-active');
						$('.quick-shop-panel .video-thumbnail-wrapper img.poster').addClass('in-active');
						$('.quick-shop-panel .video-thumbnail-wrapper video').addClass('active');

						if (video && video[videoID[1]]) {
							video[videoID[1]].play();
						}
					}
				}
			});

			$('.quick-shop-panel .product-image-container .product-images').on('afterChange', function () {
				customVideoReset();
			});

			$('.quick-shop-panel .product-image-container .product-thumbnails .product-images .slick-arrow.slick-next, .quick-shop-panel .product-image-container .product-thumbnails .product-images .slick-arrow.slick-prev').on('click', function () {
				customVideoReset();
			});

			function customVideoReset() {
				$('.quick-shop-panel .video-thumbnail-wrapper .vid-thumbnail-play-btn').removeClass('in-active');
				$('.quick-shop-panel .video-thumbnail-wrapper img.poster').removeClass('in-active');
				$('.quick-shop-panel .video-thumbnail-wrapper video').removeClass('active');
				videos.each(function (index, video) {
					video.load();
					video.pause();
				});
			}
		}, 2000);
	}
}

function initColorCatFiltersEvents() {
	// select All shades by default
	if($('.quick-shop-panel .color-filter-wrapper .color-filter-attr').length) {
		localStorage.setItem('selColorCat', $('.quick-shop-panel .color-filter-wrapper .color-filter-attr')[0].innerText);
	}
	const $routineWrapperElement = $(".add-routine-wrapper");
	// handling oos button on quick view panel
	if($(".add-to-cart-sticky .cta-wrapper").hasClass("oos-active")) {
		$routineWrapperElement.hide();
		$routineWrapperElement.prev(".add-to-cart-for-oos").hide();
		$routineWrapperElement.next(".add-to-cart-sticky").show();
	} else {
		// handling in stock products
		if($(".quick-shop-panel").hasClass("quickview-from-routine")) {
			if($(".routine-btn-for-oos").is(":visible")) {
				$routineWrapperElement.prev(".add-to-cart-for-oos").show();
				$routineWrapperElement.hide();
			} else {
				$routineWrapperElement.show();
				$routineWrapperElement.prev(".add-to-cart-for-oos").hide();
			}
			$routineWrapperElement.next(".add-to-cart-sticky").hide();
		} else {
			$routineWrapperElement.hide();
			$routineWrapperElement.prev(".add-to-cart-for-oos").hide();
			$routineWrapperElement.next(".add-to-cart-sticky").show();
		}
	}
	

	$(document).on('click', '.quick-shop-panel .color-filter-wrapper .color-filter-attr', function(e) {
		e.stopPropagation();
		if ($('.quick-shop-panel .swatches.color:not(.sticky-swatches) li').length) {
			var selectedColorCat = localStorage.getItem('selColorCat');
            var selectedValue = $(this).text();

			localStorage.setItem('selColorCat', selectedValue);
			$('.quick-shop-panel .color-filter-wrapper .color-filter-attr').removeClass('selected');
			$(this).addClass('selected');
			
			if (selectedColorCat && selectedColorCat != selectedValue) {
                // track event
                if ($('.quickview-modal').length === 0 && window.dataLayer) {
                    window.dataLayer.push(util.filterObj({
                        "event": "productInteraction",
                        "productCategory": $(".breadcrumb").find(".breadcrumb-element:eq(2)").text().trim(),
                        "productSubCategory": $(".breadcrumb").find(".breadcrumb-element:eq(3)").text().trim(),
                        "productName": $(".product-detail .product-name").text(),
                        "pageCategory": 'Product Page',
                        "productId": $('#pid').val(),
                        "interactionType": "choice of shade"
                    }));
                }
            }
									
			$('.quick-shop-panel .swatches.color:not(.sticky-swatches) li').filter(function() {
				var $this = $(this);
				var curVal = $this.data('ccatvalues') || '';
				if (curVal && curVal.indexOf(selectedValue) > -1) {
					$(this).show();
				} else {
					$(this).hide();
				}
			});
			
			if ($('.quick-shop-panel .swatches.color li:visible').length && !$('.quick-shop-panel .swatches.color li:visible').hasClass('selected')) {
				var firstSwatch;
				// select first swatch based on filtered shade
				if($('.quick-shop-panel .swatches.color li:visible').hasClass('selectable')) {
					firstSwatch = $('.quick-shop-panel .swatches.color li.selectable:visible')[0]; // select in-stack swatch
					$(firstSwatch).find('.swatchanchor').click();
				}else {
					firstSwatch = $('.quick-shop-panel .swatches.color li:not(.selectable):visible')[0]; // select OOS swatch
					$(firstSwatch).find('.swatchanchor').click();
				}
			}
		}
	});
}

function initColorCategoryFilter() {
	var selectedColorCat = localStorage.getItem('selColorCat');
	if (selectedColorCat) {
		var prevSelectedFilter = $(".quick-shop-panel .color-filter-wrapper li.color-filter-attr:contains('" + selectedColorCat +"')");
		if (prevSelectedFilter.length) {
			prevSelectedFilter.trigger('click');
		}
	}
}

function isOverflowColorShade() {
	var $colorCategoryWrapper = $('.quick-shop-panel .pdp-color-category-filter:not(.slick-initialized)'),
		$colorCategoryTile = $('.quick-shop-panel .color-filter-wrapper .pdp-color-category-filter:not(.slick-initialized) li.color-filter-attr'),
		totalWidth = 0;

	var isTablet = window.matchMedia("(max-width: 768px)").matches;
	var windowWidth = $(window).width();

	if($colorCategoryWrapper.length && $colorCategoryTile.length) {
		$colorCategoryTile.each(function(index) {
			totalWidth += $(this).outerWidth();
		});

		isTablet && $('.quick-shop-panel .pdp-color-category-filter').css({ width: windowWidth });
		return $colorCategoryWrapper.width() < totalWidth;
	}	
}

function initColorShadesSlider() {
	var $colorCategory = $('.quick-shop-panel .pdp-color-category-filter');
	if($colorCategory.length && isOverflowColorShade()) {
		$colorCategory.not('.slick-initialized').slick({
			dots: false,
			infinite: false,
			speed: 300,
			slidesToShow: 3,
			slidesToScroll: 2,
			centerMode: false,
			variableWidth: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						infinite: false,
						centerMode: false 
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						infinite: false,
						centerMode: false
					}
				}
			]
		});
	}	
}

function scrollToActiveSizeVariant() {
	var $scrollableArea = $('.quick-shop-panel .swatches.size.mobile-scrollable'),
		$activeEle;
		if($scrollableArea.length) {
			$activeEle = $scrollableArea.find('li.selected').find('.swatchanchor');
			if($scrollableArea.outerWidth() <= $activeEle.offset().left) {
				$scrollableArea.animate({scrollLeft: $scrollableArea.scrollLeft() + $activeEle.offset().left}, 500);
				checkVariantScrollReachedEnd();
			}
		}
}

function checkVariantScrollReachedEnd() {
	var $elem = $('.quick-shop-panel .swatches.size.mobile-scrollable');
	var offset = 0;
	var scrollLeft,
		ElemWidth,
		scrollWidth;
	if($elem.length) {
		scrollLeft = $elem.scrollLeft(),
		ElemWidth = $elem.width(),
		scrollWidth = $elem.get(0).scrollWidth;
		// check scroll reached to the right end
		if (scrollWidth - scrollLeft - ElemWidth === offset) {
			$(".quick-shop-panel .transparent-gradient").hide();
		} else {
			$(".quick-shop-panel .transparent-gradient").show();
		}
	}	
}

function applyTransparentGradientOnScroll() {
	$('.quick-shop-panel .product-info .swatches.size.mobile-scrollable').on('scroll', function() {
		checkVariantScrollReachedEnd();	
	});
}

function initQuickShopShadeSelector() {
	// change variation based on custom dropdown selection
	$('#quick-shop-panel, .pt_cart').on('click', '#product-content .custom-dd .custom-dd-list-item', function () {
		if($(this).closest(".content-pdp").length > 0){//PDP Specific
			var listItem =  $('#quick-shop-panel #pdp-swatches li[data-selectedcolor="'+ $(this).data("value") +'"]');
			var swatch = listItem.find('div.swatchanchor')[0];
			var pid = $(swatch).attr('data-pid');
		}else{
			var listItem =  $('#quick-shop-panel #pdp-swatches li[data-selectedcolor="'+ $(this).data("value") +'"]');
			link = listItem.find('a.swatchanchor')[0];
			var urlLink = $(link).attr('href');
			var pid = $(link).attr('data-pid');
		}		
		
		// don't change if selected variant clicked			
		if ($(this).hasClass('selected') || $(this).data("value") === '') {
			return;
		}
		
		localStorage.removeItem('selColorCat');
		var urlLink = Urls.transactionalHitTile;
		
		if(urlLink){
			updateContent(urlLink,pid);
		}
	});

	$('#quick-shop-panel, .pt_cart').on('click', '#product-content .swatchanchor', function (e) {
		e.preventDefault();

		if($(this).closest(".content-pdp").length > 0){//PDP Specific
			var pid = $(this).attr('data-pid');
		}
		else if (("#quick-shop-panel #product-content").parent().attr("id") != "product-set") {
			var pid = $(this).attr('data-pid');
			var urlLink = this.href;
			
		}

		var urlLink = Urls.transactionalHitTile;
		
		if(urlLink){
			updateContent(urlLink,pid);
		}
		
		
	})
		
}

function updateContent(href,pid, source) {
	var $pdpForm = $('#quick-shop-panel .pdpForm'),
		qty = $pdpForm.find('select[name="Quantity"] option:selected').val();
	
	var repleCycle = $('select#replencycle option:selected').length > 0 ? $('select#replencycle option:selected').val() : '0';
	const isnewregimenpropduct = $('#isnewregimenpropduct').length > 0 ? true : false;
	let regimenProductIds;
	if(isnewregimenpropduct) {
		regimenProductIds = $('#mainproductid').val() ? $('#mainproductid').val()+","+pid : pid;
	}
	var params = {
		repleCycle : repleCycle,
		Quantity: isNaN(qty) ? '1' : qty,
		format: 'ajax',
		pid: pid,
		dispallproduct:"true",
		"source":'plpquickview',
		"isnewregimenpropduct":isnewregimenpropduct,
		"productIds":regimenProductIds
	};

	ajax.load({
		url: util.appendParamsToUrl(href, params),
		target: $('#quick-shop-panel #product-content'),
		callback: function () {
			$('.quick-shop-panel .add-to-cart-sticky').addClass('show');
			quickViewImageSlider();
			customDropdown.init();
			initColorCategoryFilter();
			initColorShadesSlider();
			initColorCatFiltersEvents();
			ominibusTooltip();
			imagesLoaded('.product-thumbnails .productthumbnail').on('done', function () {
				$(document).trigger("gtvariationchange");
			});
			scrollToActiveSizeVariant();
			
			
			// scroll to selected category
			var selectedVariant = $('#quick-shop-panel #product-content .pdp-color-category-filter li.selected'); // get the selected variant
			var indexOfSelected = selectedVariant.closest('.slick-slide').attr('data-slick-index'); // know it's index
			var updatedIndex  = indexOfSelected > 1 ? indexOfSelected - 1 : indexOfSelected;
			indexOfSelected > 1 && $('#quick-shop-panel #product-content .pdp-color-category-filter').slick('slickGoTo', updatedIndex, false);

			checkVariantScrollReachedEnd();
			applyTransparentGradientOnScroll();
			
			// Enable the add-to-cart button
			if ($('.disabled-onload') && $('.disabled-onload').length > 0){
				$('.disabled-onload').removeClass('disabled-onload');
			}
		},
	})
}

function ominibusTooltip(){
	if($('.ominibus-tooltip').length > 0){
		var ominibusContent = $('.ominibus-tooltip-content');
		$('.ominibus-tooltip #ominibus-show').on('click', function(e){
			e.stopPropagation();
			$(this).closest('.ominibus-tooltip').find(ominibusContent).removeClass('hidden');
		});
		$(ominibusContent).on('click', function(e){
			e.stopPropagation();
		});
		$('.ominibus-tooltip #ominibus-hide').on('click', function(e){
			e.preventDefault();
			$(this).closest('.ominibus-tooltip').find(ominibusContent).addClass('hidden');
		});
		$('html').on('click', function(){
			!$(ominibusContent).hasClass('.hidden') && $(ominibusContent).addClass('hidden');
		});
	}
}

// quick shop Product info events end

function tileMouseHandler() {
	var isTouchDevice = ('ontouchstart' in document.documentElement);
	if (currLayoutVal == 'desktop' && $('.marketing').length == 0) {
		$('.product-tile-inner').on('mouseenter mouseleave', function (event) {
			if (isTouchDevice) {
				if (event.type == 'mouseenter') {
					$('.product-tile-inner').removeClass('active');
					$(this).addClass('active');
				} else if (event.type == 'mouseleave') {
					$(this).removeClass('active');
				}
			}
		});

		//clicking out side the tile remove the hover state.
		if (isTouchDevice) {
			$(document).on('touchstart', function (e) {
				var tile = $('.product-tile-inner');
				if ($(event.target).attr('class') != tile && !tile.has(e.target).length) {
					$('.product-tile-inner.active').removeClass('active');
				}
			});
		} else {
			$('.modal-close, .modal-close-outer, .modal-close-btn').on('click', function () {
				$('html').removeClass('modal-open');
				updateTileHeight();
			});
		}
	}
}

function closeQuickshopPanel(){
	$('.quick-shop-panel .icon-close:not(#ominibus-hide)').off('click').on('click', function () {
		$(this).closest('.quick-shop-panel').removeClass('opened quickview-from-routine');
		$(".routine-product-wrapper").removeClass("opened-quickview-routine");
		if ($('.minicart-link').find('.minicart').hasClass('opened')) {
			$('.crosssell-recommendation-modal').addClass('active');
		}
		$('.quick-shop-panel .panel-body').html('');
		setTimeout(function() {$('.quick-shop-panel').removeAttr('style')}, 500);
		$('html').removeClass('filter-open modal-open');
		if (!$(this).hasClass('.add-to-cart-sticky')) {
			analyticsEmea.quickViewClose();	
		}
		
	});
}

function closeQuickshopPanelwithRedirectLink(){
	$('.add-to-cart-sticky .text').on('click', function () {
		$('.quick-shop-panel .panel-overlay').trigger('click');
		analyticsEmea.quickViewShowDescription();
	});
}

function disableDefaultScrolling(flag) {
	var $rootElement = $('html');
	flag ? $rootElement.css('overflow', 'hidden') :  $rootElement.css('overflow', 'auto');
}

function openMinicartSlidPanel(){
	var $minicart = $("#minicart"),
		$quickshop = $(".quick-shop-panel");
	// early exit
	if(!$minicart.length) { return; }
		
	// close quickshop panel
	if($quickshop.length && $quickshop.hasClass('opened')) {
		$('.quick-shop-panel').hide();
	}

	// added flag to open mini-cart 
	$minicart.addClass("opened");
	$minicart.removeAttr('style');
	if ($('.minicart-link').find('.minicart').hasClass('opened')) {
			$('.crosssell-recommendation-modal').addClass('active');
		}
	$('html').addClass('filter-open');
	if($('.nav-redesign').length  && $(window).width() < 991) {
		$('.logo-shiseido .header-logo-default').hide();
	}
	// to reinit custom scrollbox lib	
	if ($minicart.hasClass('opened')){
		reinitMinicartScrollbox();
		analyticsEmea.cartModalOpen();
		localStorage.setItem("cartModalOpen", "miniCartOpen");
		// push event to datalayer only in mobile devices
		if(currLayoutVal === 'mobile') {
			analyticsEmea.minicartPanelOpened();
		}
		$minicart.trigger('mousemove'); // minicart slide panel close
    }
	header.updatePosFromTop(); // update drawer position from top
}

// to re-initialize scrollbar when minicart item updated
function reinitMinicartScrollbox() {
	setTimeout(function(){
		if ($('.minicart-link .sb-container .sb-content').length === 0) {
			$('.sb-container').scrollBox();
		} else {
			if ($(window).width() < 991) {
				$('.minicart-link .sb-container .sb-content').removeAttr('style');
				$(window).trigger('resize.scrollBox');
			}
		}
	}, 300);
}

function initMinicartOnRotationChange(){	
	$(window).on("resize", function( event ) {
		var $minicart = $("#minicart");
		if ($minicart.hasClass('opened') && !util.isMobile()){
			$minicart.removeClass('opened');
			$('html').removeClass('filter-open');
		}
	});
}

function minicartContinueShopping(){
	var selector = '.continue-shopping-btn-wrapper .btn[type="button"]';
	$(document).off('click', selector);	
	$(document).on('click', selector, function () {	
		// to animate minicart while closing	
		$(this).closest('#minicart').removeClass('opened').addClass('closed');
		$('html').removeClass('filter-open');
		// close minicart when remove button clicked from cart-item
		if($(this).closest('.minicart-link').hasClass("opened")) {
			$(this).closest('.minicart-link').removeClass('opened');
			$('html').removeClass('filter-open');
		}
		// push event to datalayer when minicart panel closed (only mobile)
		if(currLayoutVal === 'mobile' && !$(this).closest('#minicart').hasClass('opened')) {
			analyticsEmea.minicartPanelClosed();
		}
	});
}

function closeQuickshopPanelOutsideClick() {
	var selector = '.quick-shop-panel .panel-overlay';
	$(document).off('click', selector);
	$(document).on('click', selector, function(e) {
		e.stopPropagation();
		$(this).closest('.quick-shop-panel').removeClass('opened quickview-from-routine');
		$(".routine-product-wrapper").removeClass("opened-quickview-routine");
		$('.quick-shop-panel .panel-body').html('');
		$('html').removeClass('filter-open modal-open');
		if ($('.minicart-link').find('.minicart').hasClass('opened')) {
			$('.crosssell-recommendation-modal').addClass('active');
		}
		if (!$(this).hasClass('.add-to-cart-sticky .text')) {
			analyticsEmea.quickViewClose();	
		}
	});
}

function closeMinicartOutsideClick() {
	var selector =  '#minicart .minicart-slide-panel-overlay';
	$(document).off('click', selector);
	$(document).on('click', selector, function(e) {
		e.stopPropagation();
		$(this).closest('#minicart').removeClass('opened').addClass('closed');
		$('html').removeClass('filter-open');
		// close minicart when remove button clicked from cart-item
		if($(this).closest('.minicart-link').hasClass("opened")) {
			$(this).closest('.minicart-link').removeClass('opened');
			$('html').removeClass('filter-open');
		}
		// push event to datalayer when minicart panel closed (only mobile)	
		if(currLayoutVal === 'mobile' && !$(this).closest('#minicart').hasClass('opened')) {
			analyticsEmea.minicartPanelClosed();
		}
	});
}

// allow user to move focus on top of the screen
function backToTopEvent() {
	$('.product-listing').on('click', '.btn-flat-black.back-to-top', function(e) {
		e.stopPropagation();
		var $element = $('body');
		if($element.length) {
			$('html, body').animate({
				scrollTop: $element.offset().top || 0
			}, 500, 'linear');
		}
	});
}

/**
 * @private
 * @function
 * @description Initializes events on the product-tile for the following elements:
 * - swatches
 * - thumbnails
 */
function initializeEvents() {
	gridViewToggle();
	bindSwatchClick();
	tileQuantitySelect();
	shopByCategory();
	tileMouseHandler();
	closeQuickshopPanel();
	closeQuickshopPanelOutsideClick();
	minicartContinueShopping();
	closeMinicartOutsideClick();
	initMinicartOnRotationChange();
	backToTopEvent(); 
	switchGridEvent();
	applyTransparentGradientOnScroll();
	plpSwatchTrigger();
}

function tileHeight($tiles) {
	var noTileHeightNeeded = $('.homepage-container,.product-listing,.pt_cart,.pdp-page,.pt_content,.pt_article,.pt_account,.pt_order-confirmation,.pt_product-search-noresult,.pt_customer-service').length > 0;
	if (!noTileHeightNeeded) {
		$tiles.syncHeight({
			'updateOnResize': true,
			parentElement: '.product-tile-outer'
		}).each(function (idx) {
			$(this).data('idx', idx);
			$(this).closest('.product-tile-inner').addClass('tile-inner');
		});
	}
	$('.f-f-product-tile-wrapper .product-tile').syncHeight({ 'updateOnResize': true })
}

function setTileHeightFlag(updateLayoutVal) {
	if (updateLayoutVal == 'mobile' && $('.pt_storefront .recommendation-block').length > 0) {
		flagToSetTileHeight = false;
	} else {
		flagToSetTileHeight = true;
	}
}

$(window).on('resize orientationchange', function (event) {
	currLayoutVal = currentLayout.init();

	updateTileHeight();
	tileMouseHandler();
	delayImage.showDelayedImages();

	// Hiding the error to prevent adding extra height to tile on orientation change.
	$('.product-tile-inner.transactional #a2c-error').not('.oos').hide();

	setTimeout(function () {
		var $currLayoutVal = currentLayout.init();
		setTileHeightFlag($currLayoutVal);
		if (flagToSetTileHeight) {
			tileHeight($('.recommendation .product-tile'));
			event.stopImmediatePropagation();
		} else {
			$('.recommendation .product-tile').each(function () {
				$(this).removeAttr('style');
				$(this).closest('.product-tile-outer').removeAttr('style');
				event.stopImmediatePropagation();
			});
		}
	}, 100)
});

function updateTileHeight() {
	var $tiles = $('.product-grids-container .product-tile, .collection-block .product-tile, .recommendation .product-tile, .cart-recommendation-container .product-tile, .wishlist-item .product-tile, .products-used-wrapper .product-tile, .article-recommend-sec .product-tile, .article-body .product-tile-inner .product-tile, .f-f-product-tile-wrapper .product-tile'),
		$defendTiles = $('.to-defend .product-tile'),
		$regenerateTiles = $('.to-regenerate .product-tile');

	if ($defendTiles.length > 0) {
		tileHeight($defendTiles);
	}

	if ($regenerateTiles.length > 0) {
		tileHeight($regenerateTiles);
	}

	if ($tiles.length === 0) {
		return;
	}

	if (flagToSetTileHeight) {
		tileHeight($tiles);
	}

	delayImage.showDelayedImages();
}

//Return true if action performed buyall tiles so that pids data can be updated accordingly 
function updatePIDsReq($tileOuter) {
	var required = false;
	if ($tileOuter.parents('.regimen-bg').length > 0 || $tileOuter.parents('.tutorial-bg').length > 0 || $tileOuter.parents('.quiz-recommended-products').length > 0 || $tileOuter.parents('.f-f-application-tips').length > 0) {
		required = true;
	}
	return required;
}

function switchGridType(isClicked) {
	$('#list-view,#grid-view').toggleClass('active-view');
	$('.product-tiles-holder').toggleClass('list-view');
	if(isClicked){
		$('.tile-color-carousel').slick('slickSetOption', 'responsive', carouselSettings('color'), true);
		$('.tile-size-carousel').slick('slickSetOption', 'responsive', carouselSettings('size'), true);
		initialSlideHandler();		
			util.setCookie('mob-plp-is-listview', $('.product-tiles-holder').hasClass('list-view'), "1440");
	}
}
function initGridSwitcher() {
	if (!!window.gridSwitcherInitialized) {
		return;
	}
	window.gridSwitcherInitialized = true;
}

function switchGridEvent() {
	$('body').on("click", ".view-switcher:not('.active-view')", function () {
		switchGridType(true);
	});
}

function initSelectVariant(){
	$('#mobile-slider-variant .variation-select, .regimen-slider-variant .variation-select').unbind('selectmenuchange').on('selectmenuchange change', function () {
				
		var listItem = $(this).closest(".pdp-vars").find('li[data-selectedcolor="'+ $(this).val() +'"]');
		var link = listItem.find('a.swatchanchor')[0];
		var href = $(link).attr('href');
		
		var $selectedVariantOption = $(this).find("option:selected");
		if ($selectedVariantOption.length === 0 || !$selectedVariantOption.val()) {
			return;
		}
		localStorage.removeItem('selColorCat');
		
		var $tileOuter = $(this).closest('.product-tile-inner'),
		swatchInitialIndex = $tileOuter.find('.tile-color-carousel span.slick-current').attr('data-slick-index'),
		$tileLoader = $tileOuter.find('.tile-ajax-loader');
		util.ellipsisOnLongText($('.product-tile .product-brand-name-block .product-name'));

	$tileLoader.show();
	$tileOuter.find('.thumb-link').attr('href', $(this).attr('href'));
	$tileOuter.find('.name-link').attr('href', $(this).attr('href'));

	
	var result = JSON.parse(JSON.stringify(parseQueryString(href)));
	if($(this).parents().hasClass('regimenzone')){	
		result.isregimenpropduct = true;
		var regimenTileContent = $(this).parents('.product-tile').find('.content');
		result.content = regimenTileContent.length > 0 ? $.trim(regimenTileContent.text()) : "";
	}
		
		$.ajax({
			url: util.appendParamToURL(Urls.transactionalHitTile, 'format', 'ajax'),
			data: result,
			type: 'GET'
		}).done(function (data) {	
			$('.product-tile-inner #a2c-error').hide();
			var productImage = new Image();
			var tileImageHeight = $tileOuter.find('.thumb-link').height();
			productImage.src = $(data).find('.thumb-image')[0].src;
			var oldPid = $tileOuter.find('.product-tile').data('itemid');
			$tileOuter.html(data);
			if($tileOuter.parents('.tiles-container').find('.product-tile-outer').length < 2){
				$tileOuter.find('.thumb-link').height(tileImageHeight);
			}
			var newPid = $tileOuter.find('.product-tile').data('itemid');
			initCarouselSwatches($tileOuter, swatchInitialIndex, true);
			//if regmen add-all-to-cart button
			if(result.isregimenpropduct){
				toggleDisabilityRegimenButton($(this));
			}
			destroyQuickshopCarouselSwatches();
			bindSwatchClick();
			tileQuantitySelect();
			$tileLoader.hide();
			if (updatePIDsReq($tileOuter)) {
				buyallutil.updatepid(oldPid, newPid);
			}
			productImage.onload = function(){
				$tileOuter.find('.thumb-link').removeAttr('style');
			}
			
			// reinit custom dropdown 
			$('.quick-shop-panel .panel-body .product-tile select').selectmenu();
			$('.variation-select').selectmenu();
			setTimeout(() => {
				util.ellipsisOnLongText($('.product-tile .product-brand-name-block .product-name'));
			}, 1000);

		});
		
		
	});
}

function toggleDisabilityRegimenButton(ele){
	if ($('.regimenzone').find('.product-tile').hasClass('disabled')) {
			$("#add-all-to-cart").attr('disabled', 'disabled');
		} else {
			$("#add-all-to-cart").removeAttr('disabled');
		}
}

function regimenColorCarousel() {
	var colorCarousel = $('.regimenzone .tile-color-carousel');
	// for mobile devices only
	if($(window).width() <= 768 && colorCarousel.length) {
		// to re-init existing carousel config
		if (colorCarousel.hasClass('slick-initialized')) {
			colorCarousel.slick('destroy');
		}	
		colorCarousel.not('.slick-initialized').slick({
			arrows: true,
			dots: false,
			infinite: false,
			centerMode: false,
			variableWidth: true,
			swipeToSlide: true,
			slidesToShow: 5,
			slidesToScroll: 5
		});
		// automatically slide to selected variant
		colorCarousel.each(function() {
			var selectedVariant = $(this).find('li.selected');
			var indexOfSelected = selectedVariant.closest('.slick-slide').attr('data-slick-index');
			$(this).slick('slickGoTo', indexOfSelected, false);
		});
	}
}

function quickShopPanel() {
	var isTablet = window.matchMedia("(max-width: 768px)").matches;
	var windowWidth = $(window).width();

	if (isTablet) {
		$('.quick-shop-panel .panel-wrapper').css({width: windowWidth, right: -windowWidth});
		$('.quick-shop-panel .product-images-wrapper ').css({ width: windowWidth, height: windowWidth });
		$('.quick-shop-panel .product-details-wrapper ').css({ width: windowWidth });
	} else {
		$('.quick-shop-panel .panel-wrapper').css({ width: '', right: '' });
		$('.quick-shop-panel .product-images-wrapper ').css({ width: '', height: '' });
		$('.quick-shop-panel .product-details-wrapper ').css({ width: '' });
	}

}

function handleResize() {
	// Store the window width
	var winWidth = $(window).width();

	$(window).on('resize orientationchange', function () {
		// to prevent calling of resize event while scrolling in IOS devices
		if ($(window).width() != winWidth) {
			// Update the window width for next time
			quickShopPanel();
		}
	});
}

/**
 * plp trigger for color swatch
*/
function plpSwatchTrigger() {
    $('#search-result-items').off().on('click', '.plp-tile-swatch-wrapper a.swatchanchor', function(e) {
        e.preventDefault();		
        const $productVariations = $(this).parents('.product-variations');
        $productVariations.find('.product-loader-swatch').addClass('is-active');
        const targetContainer = $(this).parents('.product-tile-outer');
        const url = this.getAttribute('href');
        updatePLPContent(url, targetContainer, $(this));
    });
}

function updatePLPContent(href, targetContainer,$ele) {
    var result = JSON.parse(JSON.stringify(util.parseQueryString(href)));
	result.Quantity = '1';
	result.format = 'ajax';
	result.templateRender = 'product/components/producttile/redesign/transactional-producttile';
    result.isPLPAjax='true';
	   
    ajax.load({
        url: util.appendParamsToUrl(Urls.transactionalHitTile, result),
        target: targetContainer,
        callback: function () {
            variant();
			plpSwatchTrigger();
			updateTileHeight();
			initializeEvents();
			customDropdown.init();
			initColorCategoryFilter();
			initColorShadesSlider();
			initColorCatFiltersEvents();
			ominibusTooltip();
			search.initializeProductColorShadesSlider();
            if(!window.SitePreferences.ENABLE_SINGLE_TILE_IMAGE) {
				search.initPLPSlider();
			}
            $('.product-loader-swatch').removeClass('is-active');
            $('#BVRRSummaryContainer').on('click', '.bv-rating-stars-container', function() {
                window.location.href = url + '#reviews'; // redirect when rating star is clicked
            });
        }
    });
}

export default {
	init: function () {
		setTileHeightFlag(currLayoutVal);
		updateTileHeight();
		initializeEvents();
		initGridSwitcher();
		initSelectVariant();
		quickShopPanel();
		closeQuickshopPanelwithRedirectLink();
		handleResize();
		plpSwatchTrigger();
		initQuickShopShadeSelector();
	},
	initCarouselSwatches : initCarouselSwatchesHandler
}

export const initCarouselSwatches = initCarouselSwatchesHandler;